// Phase 4.6 — LXRA Color Intelligence (Color Studio)
export const COLOR = {
  root: 'color-studio-page',
  backLink: 'color-back-link',
  title: 'color-gallery-title',
  statusBadge: 'color-status-badge',
  // direction panel
  directionPanel: 'color-direction-panel',
  styleSelect: 'color-style-select',
  moodSelect: 'color-mood-select',
  prefChip: (k) => `color-pref-${k}`,
  customInput: 'color-custom-direction',
  profileSelect: 'color-profile-select',
  profileDesc: 'color-profile-description',
  saveStyleButton: 'color-save-style-button',
  saveStyleName: 'color-save-style-name',
  saveStyleConfirm: 'color-save-style-confirm',
  skinSwitch: 'color-skin-protection-switch',
  referenceList: 'color-reference-list',
  referenceChip: (id) => `color-reference-chip-${id}`,
  referenceClear: (id) => `color-reference-clear-${id}`,
  paramsSummary: 'color-params-summary',
  // analysis
  analyzeButton: 'color-analyze-button',
  reanalyzeButton: 'color-reanalyze-button',
  clearButton: 'color-clear-button',
  progress: 'color-progress',
  progressLabel: 'color-progress-label',
  jobError: 'color-job-error',
  // consistency
  consistencyPanel: 'color-consistency-panel',
  consistencyScore: 'color-consistency-score',
  consistencyMessage: 'color-consistency-message',
  consistencyIssue: (i) => `color-consistency-issue-${i}`,
  consistencyIssueSelect: (i) => `color-consistency-issue-select-${i}`,
  // grid
  filter: (k) => `color-filter-${k}`,
  grid: 'color-grid',
  empty: 'color-empty',
  noResults: 'color-no-results',
  card: (id) => `color-card-${id}`,
  cardReference: (id) => `color-card-reference-${id}`,
  cardScene: (id) => `color-card-scene-${id}`,
  cardKelvin: (id) => `color-card-kelvin-${id}`,
  cardScore: (id) => `color-card-score-${id}`,
  cardDecided: (id) => `color-card-decided-${id}`,
  cardOpen: (id) => `color-card-open-${id}`,
  cardCheckbox: (id) => `color-card-checkbox-${id}`,
  // selection
  selectionBar: 'color-selection-bar',
  selectionCount: 'color-selection-count',
  bulkAccept: 'color-bulk-accept',
  bulkReject: 'color-bulk-reject',
  bulkClear: 'color-bulk-clear',
  selectionClear: 'color-selection-clear',
  // detail sheet
  sheet: 'color-detail-sheet',
  sheetTitle: 'color-detail-title',
  sheetSummary: 'color-detail-summary',
  sheetScene: 'color-detail-scene',
  sheetSkin: 'color-detail-skin',
  sheetPalette: 'color-detail-palette',
  sheetMetric: (k) => `color-detail-metric-${k}`,
  setReference: 'color-detail-set-reference',
  acceptAll: 'color-detail-accept-all',
  rejectAll: 'color-detail-reject-all',
  rec: (p) => `color-rec-${p}`,
  recAccept: (p) => `color-rec-accept-${p}`,
  recModify: (p) => `color-rec-modify-${p}`,
  recReject: (p) => `color-rec-reject-${p}`,
  recSlider: (p) => `color-rec-slider-${p}`,
  recState: (p) => `color-rec-state-${p}`,
  sheetPrev: 'color-detail-prev',
  sheetNext: 'color-detail-next',
  // CI-2 apply / before-after
  aiSceneSwitch: 'color-ai-scene-switch',
  aiEstimate: 'color-ai-estimate',
  confirmScenesButton: 'color-confirm-scenes-button',
  applyApprovedButton: 'color-apply-approved-button',
  revertAllButton: 'color-revert-all-button',
  deliverSwitch: 'color-deliver-graded-switch',
  statChip: (k) => `color-stat-${k}`,
  styleLibraryLink: 'color-style-library-link',
  cardGraded: (id) => `color-card-graded-${id}`,
  cardAiScene: (id) => `color-card-ai-scene-${id}`,
  sheetVision: 'color-detail-vision',
  sheetVisionCaution: 'color-detail-vision-caution',
  previewButton: 'color-detail-preview-button',
  previewPanel: 'color-detail-preview',
  previewSlider: 'color-detail-preview-slider',
  previewSideBySide: 'color-detail-preview-sidebyside',
  previewModeToggle: 'color-detail-preview-mode',
  previewZoom: 'color-detail-preview-zoom',
  previewReset: 'color-detail-preview-reset',
  applyButton: 'color-detail-apply-button',
  revertButton: 'color-detail-revert-button',
  appliedBadge: 'color-detail-applied-badge',
  // Style Library
  libraryRoot: 'style-library-page',
  libraryBack: 'style-library-back',
  libraryNew: 'style-library-new',
  libraryCompareToggle: 'style-library-compare-toggle',
  libraryComparePanel: 'style-library-compare-panel',
  libraryCompareColumn: (id) => `style-library-compare-col-${id}`,
  profileCard: (id) => `style-profile-card-${id}`,
  profileEdit: (id) => `style-profile-edit-${id}`,
  profileDuplicate: (id) => `style-profile-duplicate-${id}`,
  profileDelete: (id) => `style-profile-delete-${id}`,
  profileReset: (id) => `style-profile-reset-${id}`,
  profileDefault: (id) => `style-profile-default-${id}`,
  profileCompare: (id) => `style-profile-compare-${id}`,
  profileDefaultBadge: (id) => `style-profile-default-badge-${id}`,
  profileUsage: (id) => `style-profile-usage-${id}`,
  editDialog: 'style-edit-dialog',
  editName: 'style-edit-name',
  editDescription: 'style-edit-description',
  editStyle: 'style-edit-style',
  editMood: 'style-edit-mood',
  editSkin: 'style-edit-skin',
  editFilm: 'style-edit-film',
  editParam: (k) => `style-edit-param-${k}`,
  editSave: 'style-edit-save',
  editCancel: 'style-edit-cancel',
  deleteConfirm: 'style-delete-confirm',
  deleteCancel: 'style-delete-cancel',
};
